class Translate {
    lang: string;
    catalog: {
        de?: {
            key?: string;
        }
    } = {};

    addCatalog(lang: string, catalog) {
        this.catalog[lang] = catalog[lang];
    }

    getCatalog(lang: string) {
        return this.catalog[lang] || {};
    }

    locale(lang: string) {
        this.lang = lang;
    }

    gettext(key: string) {
        const catalog = this.getCatalog(this.lang);
        return catalog[key] || key;
    }

    format(str: string, data) {
        var args = String(str).replace(/\{\{|\}\}/g, '').match(/\{[^{}]+\}/g) || [],
            params = arguments.length > 2 ? Array.prototype.slice.call(arguments, 1) : (typeof data === 'object' ? data : [data]);

        for (var arg; !!(arg = args.shift());) {
            var name = arg.substr(1, arg.length - 2);
            str = str.replace(arg, params[name]);
        }

        return str ? str.replace(/\{\{/g, "{").replace(/\}\}/g, "}") : str;
    }
}

const defaultTranslate = new Translate();

export {
    Translate
};

export default defaultTranslate;


// WEBPACK FOOTER //
// ./src/locale/translate.ts